var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-chip',{class:_vm.getPriorityClass(_vm.text),attrs:{"small":"","outlined":""}},[_vm._v(_vm._s(_vm.getData(_vm.text)))])}
var staticRenderFns = []

export { render, staticRenderFns }